import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './IncentiveListScreen';
import IncentiveList from './IncentiveListScreen';
import { StoreState } from 'src/store/reducers';
import { getIncentives, getIncentivesCsv } from 'src/store/actions/incentive-actions';
import { QueryParams } from 'src/types/grid';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.incentives.data,
        inProgress: state.incentives.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getIncentives(params)),
        getDataCsv: (params: QueryParams) => dispatch(getIncentivesCsv(params)),
    };
}

const IncentiveListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(IncentiveList);

export default IncentiveListScreen;
